import Directory from '~/models/abstracts/Directory'
import ChainInheritance from '~/models/mixins/ChainInheritance'

export default class Acts extends ChainInheritance(Directory, []) {
  static entity = 'acts'
  static paginated = true
  static ormLoadWithRelations = true
  static defaultSortParam = 'startDate'

  static ormTrans = {
    single: 'Act',
    multy: 'Acts'
  }

  static fields () {
    return {
      id: this.attr(null),
      organization: this.attr(null),
      invoice: this.attr(null),
      startDate: this.attr(null),
      endDate: this.attr(null),
      date: this.attr(null),
      newCRPDetails: this.attr(null),
      overflowCRPDetails: this.attr(null),
      userFullName: this.attr(null)
    }
  }

  get startDateString () {
    return this.getDateTime(this.startDate)
  }

  get endDateString () {
    return this.getDateTime(this.endDate)
  }

  get dateString () {
    return this.getDateTime(this.date)
  }

  static ormHeaders = [
    { text: 'User', value: 'userFullName', sortable: true, filterable: false },
    { text: 'Start date', value: 'startDateString', sortable: true, filterable: false },
    { text: 'End date', value: 'endDateString', sortable: true, filterable: false },
    { text: 'Date of act', value: 'dateString', sortable: true, filterable: false },
    { text: 'Actions', align: 'center', value: 'actions', width: '72', sortable: false, filterable: false }
  ]

  static ormFilters = [
    {
      model: 'search',
      component: 'v-text-field',
      attrs: {
        outlined: true,
        'hide-details': true,
        placeholder: 'Search',
        'prepend-inner-icon': 'mdi-magnify'
      },
      classes: ['filled-input']
    }
  ]

  static ormFiltersConfig = {
    default: {
      grid: [
        {
          component: 'v-row',
          attrs: {
            justify: 'end'
          },
          nodes: [
            {
              component: 'v-col',
              attrs: {
                cols: 12
              },
              fields: [
                'search'
              ]
            }
          ]
        }
      ]
    }
  }

  static ormActions = [
    {
      name: 'downloadPdf',
      text: 'Download PDF',
      icon: {
        type: 'e-svg-icon',
        text: 'pdf'
      },
      call: async (item) => {
        if (item && item.id) {
          const res = await Acts.api().get(Acts.$routes[Acts.entity].getFile(item.id), {
            save: false,
            responseType: 'blob'
          })
          const blob = new Blob([this._.get(res, 'response.data', '')], { type: 'application/pdf' })
          window.open(URL.createObjectURL(blob), '_blank')
        }
      }
    }
  ]
}
